export const appointmentFr = {
  "Matin": "Matin",
  "Soir": "Soir",
  "Lundi": "Lundi",
  "Mardi": "Mardi",
  "Mercredi": "Mercredi",
  "Jeudi": "Jeudi",
  "Vendredi": "Vendredi",
  "Samedi": "Samedi",
  "Dimanche": "Dimanche",
  "Rendez-vous DR.": "Rendez-vous DR.",

  "Montée": "Montée",
  "Descente": "Descente",
  "Temps": "Temps",
  "NBS.SN": "NBS.SN",
  "Nombre de seance": "Nombre de seance",
  "Jour du travail": "Jours du travail",
  "Pause": "Pause",
  "Filter": "Filtrer",
  "Supprimer le rendez-vous": "Supprimer le rendez-vous",
  "Supprimer l'acte": "Supprimer l'acte",

  // Server side 

  "Le rendez-vous existe deja": "Le rendez-vous existe deja",
  "Le patient est obligatoire": "Le patient est obligatoire",
  "Date de rendez-vous est obligatoire": "Date de rendez-vous est obligatoire",
  "Heure de rendez-vous est obligatoire": "Heure de rendez-vous est obligatoire",
  "Vous etes obligé de choisir un jour.": "Vous etes obligé de choisir un jour.",
  "deja existe": "deja existe",
  "le nom est obligatoire": "le nom est obligatoire",
  "Choisir un temps partiel": "Choisir un temps partiel",
  "Donner la date du debut du : matin": "Donner la date du debut du : matin",
  "Donner la date du debut du : soir": "Donner la date du debut du : soir",
  "Donner la date du descente du : matin": "Donner la date du descente du : matin",
  "Donner la date du descente du : soir": "Donner la date du descente du : soir",
  
  "Démain": "Démain",
  "Aprés Démain": "Aprés Démain",
  "Hier": "Hier",
  "Avant-hier": "Avant-hier",
  "Aprés": "Aprés",
  "jours": "jours",
  "Avant": "Avant",

}
